module.exports = __webpack_public_path__ + "img/115045.75039da4.png";